var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SignalRConnection_1 = __importDefault(require("./SignalRConnection"));
const CACHE_KEY_PREFIX = 'henderson-signalr-connections-';
function getSignalRConnection(hubName) {
    let connection = getCachedSignalRConnection(hubName);
    if (!connection) {
        connection = new SignalRConnection_1.default(hubName);
        cacheSignalRConnection(hubName, connection);
    }
    return connection;
}
function getCachedSignalRConnection(hubName) {
    return window[getCacheKey(hubName)];
}
function cacheSignalRConnection(hubName, connection) {
    window[getCacheKey(hubName)] = connection;
}
function getCacheKey(hubName) {
    return `${CACHE_KEY_PREFIX}-${hubName}`;
}
exports.default = getSignalRConnection;
//# sourceMappingURL=getSignalRConnection.js.map